(function () {
  'use strict';

  function initCardsSlider() {
    var allSliders = document.querySelectorAll('[data-cards-slider]');
    if (!allSliders.length) return;

    allSliders.forEach(function (slider) {
      var slides = slider.querySelectorAll('.cards-slider__slide');
      var section = slider.closest('.cards-slider');
      if (!section || !slides.length) return;

      var sliderWrapper = slider.closest('.cards-slider__slider-wrapper');
      var indicatorsContainer = section.querySelector('.cards-slider__nav-indicators');
      var prevButton = section.querySelector('.cards-slider__nav-button--prev');
      var nextButton = section.querySelector('.cards-slider__nav-button--next');

      var desktopPerView = parseInt(section.dataset.slidesPerViewDesktop || section.getAttribute('data-slides-desktop') || 3, 10);
      var tabletPerView  = parseInt(section.dataset.slidesPerViewTablet  || section.getAttribute('data-slides-tablet')  || 2, 10);
      var mobilePerView  = parseInt(section.dataset.slidesPerViewMobile  || section.getAttribute('data-slides-mobile')  || 1, 10);

      var config = {
        totalSlides: slides.length,
        slidesPerViewDesktop: desktopPerView || 3,
        slidesPerViewTablet:  tabletPerView  || 2,
        slidesPerViewMobile:  mobilePerView  || 1,
        slidesPerView: 3,
        currentPage: 0,
        totalPages: 1,
        isScrolling: false,
        scrollTimeout: null
      };

      function updateSlidesPerView() {
        var width = window.innerWidth;

        if (width >= 990) {
          config.slidesPerView = config.slidesPerViewDesktop;
        } else if (width >= 768) {
          config.slidesPerView = config.slidesPerViewTablet;
        } else {
          config.slidesPerView = config.slidesPerViewMobile;
        }

        config.totalPages = Math.max(1, Math.ceil(config.totalSlides / config.slidesPerView));
        if (config.currentPage >= config.totalPages) {
          config.currentPage = config.totalPages - 1;
        }
      }

      function createIndicators() {
        if (!indicatorsContainer) return;

        indicatorsContainer.innerHTML = '';
        for (var i = 0; i < config.totalPages; i++) {
          var indicator = document.createElement('button');
          indicator.className = 'cards-slider__nav-indicator';
          indicator.type = 'button';
          indicator.setAttribute('data-indicator', String(i));
          indicator.setAttribute('aria-label', 'Go to page ' + (i + 1));
          if (i === config.currentPage) {
            indicator.classList.add('cards-slider__nav-indicator--active');
          }

          indicator.addEventListener('click', function () {
            var index = parseInt(this.getAttribute('data-indicator'), 10);
            if (isNaN(index)) return;
            config.currentPage = index;
            updateSlider(true);
          });

          indicatorsContainer.appendChild(indicator);
        }
      }

      function updateIndicators() {
        if (!indicatorsContainer) return;

        var allIndicators = indicatorsContainer.querySelectorAll('.cards-slider__nav-indicator');
        allIndicators.forEach(function (indicator, index) {
          if (index === config.currentPage) {
            indicator.classList.add('cards-slider__nav-indicator--active');
          } else {
            indicator.classList.remove('cards-slider__nav-indicator--active');
          }
        });
      }

      function updateSlider(fromButton) {
        updateSlidesPerView();

        var width = window.innerWidth;
        var isDesktop = width >= 990;
        var isMobile  = width < 768;

        var slideWidth = slides[0].offsetWidth;
        var gap;

        if (isDesktop) {
          gap = 20;
        } else if (isMobile) {
          gap = 12;
        } else {
          gap = 16;
        }

        if (isDesktop) {
          var offset = -(config.currentPage * config.slidesPerView * (slideWidth + gap));
          slider.style.transform = 'translateX(' + offset + 'px)';
        } 
        else {
          if (fromButton && sliderWrapper) {
            config.isScrolling = true;
            var scrollPosition = config.currentPage * config.slidesPerView * (slideWidth + gap);
            sliderWrapper.scrollTo({
              left: scrollPosition,
              behavior: 'smooth'
            });
            
            setTimeout(function() {
              config.isScrolling = false;
            }, 500);
          }
        }

        updateIndicators();
      }

      function handleScroll() {
        var width = window.innerWidth;
        if (width >= 990 || config.isScrolling || !sliderWrapper) return;

        clearTimeout(config.scrollTimeout);
        
        config.scrollTimeout = setTimeout(function() {
          syncPageWithScroll();
        }, 100);
      }

      function syncPageWithScroll() {
        var width = window.innerWidth;
        if (width >= 990 || !sliderWrapper) return;

        var scrollLeft = sliderWrapper.scrollLeft;
        var slideWidth = slides[0].offsetWidth;
        var isMobile = width < 768;
        var gap = isMobile ? 12 : 16;
        var slideWithGap = slideWidth + gap;
        
        var calculatedPage = Math.round(scrollLeft / (config.slidesPerView * slideWithGap));
        var newPage = Math.max(0, Math.min(calculatedPage, config.totalPages - 1));
        
        if (newPage !== config.currentPage) {
          config.currentPage = newPage;
          updateIndicators();
        }
      }

      if (sliderWrapper) {
        sliderWrapper.addEventListener('scroll', handleScroll, { passive: true });
      }

      if (prevButton && nextButton) {
        prevButton.addEventListener('click', function () {
          config.currentPage = (config.currentPage - 1 + config.totalPages) % config.totalPages;
          updateSlider(true);
        });

        nextButton.addEventListener('click', function () {
          config.currentPage = (config.currentPage + 1) % config.totalPages;
          updateSlider(true);
        });
      }

      var resizeTimer = null;
      window.addEventListener('resize', function () {
        if (resizeTimer) window.clearTimeout(resizeTimer);
        resizeTimer = window.setTimeout(function () {
          updateSlider(false);
        }, 250);
      });

      updateSlidesPerView();
      createIndicators();
      updateSlider(false);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      initCardsSlider();
    });
  } else {
    initCardsSlider();
  }

})();
